import { tw } from '@/utils/tw';
import InputCaptionTheme from 'base/components/InputCaption/theme';

const Caption = tw.theme({
  extend: InputCaptionTheme,
  base: 'text-body-sm group-data-[status=error]:text-error-500',
});

export default Caption;
